module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['sky-reveal', {
      closed: !_vm.isOpen
    }],
    attrs: {
      "aria-expanded": _vm.ariaExpanded
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// F:/Solutions/6713ge/master/~/vue-loader/lib/template-compiler?{"id":"data-v-1e7cd0c8"}!./scripts/sky-reveal/sky-reveal.html
// module id = 344
// module chunks = 1